import { hc } from "hono/client";

import type { AppType } from "@repo/api/types";

// Im Dev läuft alles über den Vite-Proxy (same-origin), in Produktion kann
// VITE_API_URL auf eine andere Domain zeigen.
const baseUrl = import.meta.env.VITE_API_URL ?? window.location.origin;

export const api = hc<AppType>(baseUrl, {
  // Ohne das würde das HttpOnly-Session-Cookie nicht mitgeschickt.
  init: { credentials: "include" },
});

/** Liest die Fehlermeldung des Backends aus, sonst eine generische. */
export async function errorMessage(res: Response, fallback: string): Promise<string> {
  try {
    const body = (await res.json()) as { error?: unknown };
    if (typeof body.error === "string") return body.error;
    return validierungsFehler(body.error) ?? fallback;
  } catch {
    return fallback;
  }
}

/** Validierungsfehler (400) kommen als ZodError; dessen message ist die JSON-Liste der Probleme. */
function validierungsFehler(error: unknown): string | null {
  if (typeof error !== "object" || error === null || !("message" in error) || typeof error.message !== "string") {
    return null;
  }
  try {
    const probleme = JSON.parse(error.message) as { path?: (string | number)[]; message?: string }[];
    if (!Array.isArray(probleme) || probleme.length === 0) return null;
    return probleme.map((p) => (p.path?.length ? `${p.path.join(".")}: ${p.message}` : p.message)).join(" · ");
  } catch {
    return null;
  }
}
